import { api } from '../../../../helpers/api/api';
import { AuthAction, AuthActionTypes } from '../../actions/auth/auth.types';
import { AuthState } from '../../types/auth.types';

const initialState: AuthState = {
  user: api.getLoggedInUser(),
  loading: false,
};

export const Auth = (state = initialState, action: AuthAction): AuthState => {
  switch (action.type) {
    // Login cases
    case AuthActionTypes.LOGIN_USER:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.user,
        loading: false,
      };
    case AuthActionTypes.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Signup cases
    case AuthActionTypes.SIGNUP_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AuthActionTypes.SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case AuthActionTypes.SIGNUP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Forgot password cases
    case AuthActionTypes.FORGOT_PASSWORD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AuthActionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case AuthActionTypes.FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Reset password cases
    case AuthActionTypes.FORGOT_PASSWORD_CHANGE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AuthActionTypes.FORGOT_PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case AuthActionTypes.FORGOT_PASSWORD_CHANGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Logout cases
    case AuthActionTypes.LOGOUT_USER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AuthActionTypes.LOGOUT_SUCCESS:
      return {
        ...initialState,
        user: null,
      };
    case AuthActionTypes.LOGOUT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Reset case
    case AuthActionTypes.RESET:
      return initialState;

    default:
      return state;
  }
};
